import axios from "../../Plugins/axios";

export class MenuService {
    async get() {
        let error = null;
        let response = null;
        try {
            response = await axios.get("menu-list");
        } catch (err) {
            error = err;
        }

        return [response, error];
    }
}
